import { useEffect, useState } from 'react';
import { APP_VERSION } from '../version';

// Polls /version.json on an interval and on tab-focus. When the served
// version differs from the version baked into this bundle, returns the
// new version string so the caller can prompt the user to reload.
//
// /version.json is generated at build time from src/version.js (see
// scripts/write-version.js) and lives in /public so it sits next to
// index.html and is served without a content hash. Make sure your static
// host serves it with `Cache-Control: no-cache` (same as index.html) or
// the browser will keep handing back the old value.

const POLL_INTERVAL_MS = 60 * 1000; // 60s

export default function useVersionCheck() {
  const [latestVersion, setLatestVersion] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        // Cache-buster query param — belt-and-suspenders in case a proxy
        // ignores no-cache headers.
        const res = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store',
        });
        if (!res.ok) return;
        const data = await res.json();
        if (cancelled) return;
        if (data && data.version && data.version !== APP_VERSION) {
          setLatestVersion(data.version);
        }
      } catch {
        // Network blip — try again next tick.
      }
    }

    check();
    const interval = setInterval(check, POLL_INTERVAL_MS);
    const onVisibility = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  return { currentVersion: APP_VERSION, latestVersion };
}
